import i18next from "i18next";
import { Stack, Button, Col, Row } from "react-bootstrap";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { RoleEnum } from "src/api";
import { useAuth } from "src/hooks/useAuth";
import { format as formatFns } from 'date-fns';
import { formatDate } from '../../../utils';
import { ExternalChecklistDTO } from "src/api/models/Opportunities/ExternalChecklistDTO";
import Btn from "src/components/Btn/Btn";

type Props = {
  isBusy?: boolean;
  checklist: ExternalChecklistDTO | null;
  isOpportunityClosed: boolean;
  isOpportunityReadOnly?: boolean;
  actions: {
    openRequestDocumentModal: Function
    requestDocumentation: Function
    uploadDocumentsOnExternal: Function
  }
}

const ChecklistCreation = ({ checklist }: any) => {
  const isChecklistCreated = !!checklist?.createdAt;
  const resendRequest = isChecklistCreated && checklist?.externalLoading

  if (!resendRequest) {
    return (
      <p>
        {i18next.t('send_link_to_client_to_upload_checklist')}
      </p>
    )
  }

  if (isChecklistCreated) {
    const date = checklist?.requestedAt || checklist?.createdAt

    return (
      <div className="d-flex align-items-start">
        <div>
          <IoIosCheckmarkCircleOutline className="text-success me-2 d-block" size={24} />
        </div>
        <p className="mt-1">
          {
            i18next.t('requested_documentation_date', {
              date: formatDate(date, i18next.language, false),
              time: formatFns(date, 'HH:mm')
            })
          }
        </p>
      </div>
    )
  }

  return (
    <p>
      {i18next.t('send_link_to_client_to_upload_checklist')}
    </p>
  )
}

export default function OpportunityChecklistActions({ checklist, isOpportunityClosed, actions, isBusy = false, isOpportunityReadOnly = false }: Props) {
  const { userRole } = useAuth();
  const isSegnalatore = RoleEnum.SEGNALATORE == userRole;
  const isChecklistCreated = !!checklist?.createdAt;

  const isAnySales = [
    RoleEnum.SALES_DEALER,
    RoleEnum.SALES,
    RoleEnum.SALES_INTERNAL,
  ].includes(userRole);

  const isBam = [
    RoleEnum.BACKOFFICE,
    RoleEnum.AREA_MANAGER,
    RoleEnum.MASTER,
  ].includes(userRole);

  if (isOpportunityClosed) {
    return null;
  }

  const resendRequest = isChecklistCreated && checklist?.externalLoading

  if (isBam && isChecklistCreated) {
    return (<Stack gap={1} className="mt-4">
      <div className="d-flex align-items-center justify-content-between">
        <p>
        </p>
        <Button
          size='lg'
          disabled={isBusy}
          className='mt-3'
          onClick={() => {
            actions?.openRequestDocumentModal(true);
          }}
        >
          {i18next.t('add_request_document')}
        </Button>
      </div>
    </Stack>)
  }

  if (isSegnalatore) {
    return (<Stack gap={1} className="mt-4">
      <Row className="d-flex align-items-start justify-content-between">
        <Col className="flex-grow-1">
          <ChecklistCreation checklist={checklist} />
        </Col>
        <Col className="d-flex justify-content-end">
          <Button size="lg" onClick={() => actions?.requestDocumentation()} disabled={isBusy || isOpportunityReadOnly}>
            {resendRequest ? i18next.t('resend_request_documentation') : i18next.t('request_documentation')}
          </Button>
        </Col>
      </Row>
    </Stack>)
  }

  if (isAnySales) {
    return (<Stack gap={1} className="mt-4">
      <Row className="d-flex align-items-start justify-content-between">
        <Col className="flex-grow-1">
          <ChecklistCreation checklist={checklist} />
        </Col>
        <Col className="d-flex justify-content-end">
          <Button size="lg" onClick={() => actions?.requestDocumentation()} disabled={isBusy || isOpportunityReadOnly}>
            {resendRequest ? i18next.t('resend_request_documentation') : i18next.t('request_documentation')}
          </Button>
        </Col>
      </Row>
      < hr />
      <Row className="d-flex align-items-start justify-content-between">
        <Col className="flex-grow-1">
          <p>
            {i18next.t('upload_checklist_manually')}
          </p>
        </Col>
        <Col className="d-flex justify-content-end">

          <Btn size="lg" onClick={() => actions?.uploadDocumentsOnExternal()} disabled={isBusy || isOpportunityReadOnly}>
            {i18next.t('upload_documents')}
          </Btn>
        </Col>
      </Row>
    </Stack>)
  }

  return null;
}
